module.exports = __webpack_public_path__ + "img/17a003-15.8b4496be.png";